import {
	Button,
	Icon,
	PopperWrapper
} from "~/components";
import Tippy from '@tippyjs/react/headless';
import {Tooltip} from "antd";
import {useState} from "react";

function UserTableAction({item, setItemEdit, handleEvent, can}) {

	const [loading, setLoading] = useState(false)

	const [loadingBlock, setLoadingBlock] = useState(false)

	const [showActionBox, setShowActionBox] = useState(false);

	const closeActionButton = () => {
		setShowActionBox(false);
	};

	const handleButtonClick = {
		password: () => {
			closeActionButton();
			setItemEdit(item)
			handleEvent.openModal('password')
		},
		role: () => {
			closeActionButton();
			setItemEdit(item)
			handleEvent.openModal('role')
		},
		edit: () => {
			setItemEdit(item)
			handleEvent.openModal('edit')
		},
		active: async () => {
			setLoading(true)
			await handleEvent.active(item);
			setLoading(false)
		},
		block: async () => {
			setLoadingBlock(true)
			await handleEvent.block(item);
			setLoadingBlock(false)
		}
	}

	const renderActionButton = () => {
		return (
			<PopperWrapper className={'action-wrapper'}>
				{can.password && <Button type="button" onClick={handleButtonClick.password}>Đổi mật khẩu</Button>}
				{can.role && <Button type="button" onClick={handleButtonClick.role}>Đổi chức vụ</Button>}
			</PopperWrapper>
		)
	}

	return (
		<>
			{
				(can.edit) && <Tooltip title="Cập nhật tài khoản">
					<Button small background blue onClick={handleButtonClick.edit}>
						{Icon.edit}
					</Button>
				</Tooltip>
			}
			{
				(item.status.value !== 'public' && can.status) && <Tooltip title="Duyệt tài khoản">
					<Button small background green onClick={handleButtonClick.active} disabled={loading}>
						{loading ? Icon.loading : Icon.success}
					</Button>
				</Tooltip>
			}
			{
				(item.status.value !== 'block' && can.status) && <Tooltip title="Khóa tài khoản">
					<Button small background red onClick={handleButtonClick.block} disabled={loadingBlock}>
						{loadingBlock ? Icon.loading : Icon.block}
					</Button>
				</Tooltip>
			}
			<Tippy
				interactive
				visible={showActionBox}
				render={renderActionButton}
				onClickOutside={closeActionButton}
				placement="bottom" offset={[35, 5]}
			><Button type="button" small onClick={() => setShowActionBox(true)} background blue>{Icon.menuVertical}</Button></Tippy>
		</>
	)
}

export default UserTableAction;